(() => {
  // This file is included by both the layout and the cart drawer section. Two copies racing
  // each other would each add a bag, so only the first one to load runs.
  if (window.__unFreeGiftLoaded) return;
  window.__unFreeGiftLoaded = true;

  const CONFIG = {
    qualifyingProductHandle: 'collagen',
    // The bag is a normal £15 product; the "Free Bag" automatic discount makes it £0 with a collagen subscription.
    giftProductHandle: 'elle-sera-limited-edition-red-cosmetic-bag',
    cartDrawerSectionId: '0-cart-drawer',
    giftVariantId: 57092948820341,

    giftVariantTitle: '',
    giftQuantity: 1,

    giftLineItemProperties: {
      _auto_free_gift: 'true'
    }
  };

  let isSyncing = false;
  let cachedProducts = null;
  let syncTimeoutId = null;
  let networkHooksBound = false;

  async function fetchJSON(url, options = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(options.headers || {})
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${url} (${response.status})`);
    }

    return response.json();
  }

  async function loadProducts() {
    if (cachedProducts) return cachedProducts;

    const [qualifyingProduct, giftProduct] = await Promise.all([
      fetchJSON(`/products/${CONFIG.qualifyingProductHandle}.js`),
      fetchJSON(`/products/${CONFIG.giftProductHandle}.js`)
    ]);

    const qualifyingVariant = qualifyingProduct.variants.find((variant) => variant.available) || qualifyingProduct.variants[0];
    const qualifyingSellingPlanGroup = qualifyingProduct.selling_plan_groups && qualifyingProduct.selling_plan_groups[0];
    const qualifyingSellingPlan = qualifyingSellingPlanGroup && qualifyingSellingPlanGroup.selling_plans
      ? qualifyingSellingPlanGroup.selling_plans[0]
      : null;

    const giftVariant = CONFIG.giftVariantId
      ? giftProduct.variants.find((variant) => variant.id === CONFIG.giftVariantId)
      : CONFIG.giftVariantTitle
        ? giftProduct.variants.find(
          (variant) => variant.title.trim().toLowerCase() === CONFIG.giftVariantTitle.trim().toLowerCase()
        )
        : giftProduct.variants.find((variant) => variant.available) || giftProduct.variants[0];

    if (!giftVariant || !qualifyingVariant || !qualifyingSellingPlan) {
      throw new Error('Required gift or subscription data could not be resolved');
    }

    cachedProducts = {
      qualifyingProduct,
      qualifyingVariant,
      qualifyingSellingPlan,
      giftProduct,
      giftVariant
    };

    return cachedProducts;
  }

  async function getCart() {
    return fetchJSON('/cart.js');
  }

  function isSubscriptionLineItem(item) {
    return !!(item.selling_plan_allocation || item.selling_plan);
  }

  function cartHasQualifyingProduct(cart, qualifyingProductId) {
    return cart.items.some((item) => {
      return item.product_id === qualifyingProductId && isSubscriptionLineItem(item);
    });
  }

  function isAutoGiftItem(item, giftVariantId) {
    return item.variant_id === giftVariantId
      && item.properties
      && item.properties._auto_free_gift === 'true';
  }

  function findAutoGiftLineItems(cart, giftVariantId) {
    return cart.items.filter((item) => isAutoGiftItem(item, giftVariantId));
  }

  function findGiftLineItems(cart, giftVariantId) {
    return cart.items.filter((item) => item.variant_id === giftVariantId);
  }

  function getGiftQuantity(cart, giftVariantId) {
    return findGiftLineItems(cart, giftVariantId)
      .reduce((total, item) => total + item.quantity, 0);
  }

  async function addGift(variantId) {
    await fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: CONFIG.giftQuantity,
            properties: CONFIG.giftLineItemProperties
          }
        ]
      })
    });
  }

  async function addQualifyingSubscription(variantId, sellingPlanId) {
    await fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: {
              _auto_added_with_free_gift: 'true'
            }
          }
        ]
      })
    });
  }

  async function removeGiftByKey(lineItemKey) {
    await fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      })
    });
  }

  async function updateLineItemQuantity(lineItemKey, quantity) {
    await fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: quantity
      })
    });
  }

  async function refreshCartUI() {
    const [cart, drawerHTML] = await Promise.all([
      getCart(),
      fetch(`/?section_id=${CONFIG.cartDrawerSectionId}&r=${Math.random()}`, {
        credentials: 'same-origin'
      }).then((response) => response.text())
    ]);

    document.querySelectorAll('.custom-header__cart-counts span')
      .forEach((element) => {
        element.textContent = cart.item_count;
      });

    const container = document.createElement('div');
    container.innerHTML = drawerHTML;

    const newDrawer = container.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');
    const wasDrawerOpen = currentDrawer && currentDrawer.classList.contains('active');

    if (newDrawer && currentDrawer) {
      currentDrawer.replaceWith(newDrawer);
      newDrawer.setAttribute('data-cart-count', String(cart.item_count));

      if (wasDrawerOpen && typeof newDrawer.open === 'function') {
        newDrawer.open();
      }
    }
  }

  async function syncFreeGift() {
    if (isSyncing) return;

    try {
      isSyncing = true;

      const {
        qualifyingProduct,
        qualifyingVariant,
        qualifyingSellingPlan,
        giftVariant
      } = await loadProducts();
      const cart = await getCart();

      const qualifies = cartHasQualifyingProduct(cart, qualifyingProduct.id);
      const autoGiftItems = findAutoGiftLineItems(cart, giftVariant.id);
      const giftItems = findGiftLineItems(cart, giftVariant.id);
      const totalAutoGiftQuantity = autoGiftItems.reduce((total, item) => total + item.quantity, 0);

      if (qualifies && giftItems.length === 0) {
        await addGift(giftVariant.id);
        await refreshCartUI();
        document.dispatchEvent(new CustomEvent('free-gift:updated', { detail: { action: 'added' } }));
        return;
      }

      if (totalAutoGiftQuantity > CONFIG.giftQuantity) {
        let remainingAllowedQuantity = CONFIG.giftQuantity;

        for (const giftItem of autoGiftItems) {
          const nextQuantity = remainingAllowedQuantity > 0
            ? Math.min(giftItem.quantity, remainingAllowedQuantity)
            : 0;

          if (giftItem.quantity !== nextQuantity) {
            await updateLineItemQuantity(giftItem.key, nextQuantity);
          }

          remainingAllowedQuantity -= nextQuantity;
        }

        await refreshCartUI();
        document.dispatchEvent(new CustomEvent('free-gift:updated', { detail: { action: 'quantity-corrected' } }));
        return;
      }

      if (!qualifies && autoGiftItems.length > 0) {
        for (const giftItem of autoGiftItems) {
          await removeGiftByKey(giftItem.key);
        }

        await refreshCartUI();
        document.dispatchEvent(new CustomEvent('free-gift:updated', { detail: { action: 'removed' } }));
      }
    } catch (error) {
      console.error('Free gift sync error:', error);
    } finally {
      isSyncing = false;
    }
  }

  function queueSync(delay = 700) {
    window.clearTimeout(syncTimeoutId);
    syncTimeoutId = window.setTimeout(syncFreeGift, delay);
  }

  function shouldWatchCartRequest(url) {
    if (!url) return false;

    return [
      '/cart/add.js',
      '/cart/change.js',
      '/cart/update.js',
      '/cart/clear.js'
    ].some((path) => String(url).indexOf(path) !== -1);
  }

  function bindCartNetworkHooks() {
    if (networkHooksBound) return;
    networkHooksBound = true;

    const nativeFetch = window.fetch;

    if (typeof nativeFetch === 'function') {
      window.fetch = function (...args) {
        const request = nativeFetch.apply(this, args);
        const requestUrl = args[0] && args[0].url ? args[0].url : args[0];

        if (shouldWatchCartRequest(requestUrl)) {
          request
            .then((response) => {
              if (response && response.ok) {
                queueSync(150);
              }
            })
            .catch(() => {});
        }

        return request;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__freeGiftWatchedUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (shouldWatchCartRequest(this.__freeGiftWatchedUrl)) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            queueSync(150);
          }
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function bindCartPageQuantityLock() {
    document.addEventListener('input', (event) => {
      const input = event.target;

      if (!input || !input.matches('[data-quantity-input]')) return;

      const quantityWrapper = input.closest('[data-free-gift-locked="true"]');
      if (!quantityWrapper) return;

      if (parseInt(input.value || '0', 10) > CONFIG.giftQuantity) {
        input.value = String(CONFIG.giftQuantity);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindCartNetworkHooks();
    bindCartPageQuantityLock();
    syncFreeGift();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      queueSync();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '[name="add"], .product-form__submit, .ajax-add-to-cart, .cart__remove, .cart-remove, .cart-drawer, [data-cart-remove]'
    );

    if (trigger) {
      queueSync();
    }
  }, true);

  window.syncFreeGift = syncFreeGift;
})();
